export enum FeatureRequestStatus {
  submitted = 'submitted',
  underReview = 'under_review',
  planned = 'planned',
  inDevelopment = 'in_development',
  completed = 'completed',
  rejected = 'rejected',
  duplicate = 'duplicate',
}

export enum FeatureRequestPriority {
  low = 'low',
  medium = 'medium',
  high = 'high',
  critical = 'critical',
}

export interface FeatureRequest {
  id: string;
  title: string;
  description: string;
  status: FeatureRequestStatus;
  priority: FeatureRequestPriority;
  
  // User information
  submittedBy: string; // User ID
  submittedByName?: string;
  submittedByEmail?: string;
  submittedByRole?: 'member' | 'employer' | 'provider';
  
  // Voting/Support
  votes: number; // Number of users who voted for this
  voters: string[]; // User IDs who voted
  
  // Assignment
  assignedTo?: string; // Developer/staff user ID
  assignedToName?: string;
  
  // Related entities
  relatedTickets?: string[]; // Related helpdesk ticket IDs
  relatedFeatureRequests?: string[]; // Related feature request IDs
  
  // Implementation tracking
  estimatedEffort?: string; // e.g., "2 weeks", "1 month"
  targetRelease?: string; // Target release version/date
  actualRelease?: string; // Actual release version/date
  
  // Comments
  comments: FeatureRequestComment[];
  
  // Metadata
  tags: string[];
  category?: string; // e.g., "mobile", "web", "admin", "provider"
  metadata?: Record<string, unknown>;
  
  // Timestamps
  createdAt: Date;
  updatedAt: Date;
  completedAt?: Date;
}

export interface FeatureRequestComment {
  id: string;
  featureRequestId: string;
  authorId: string;
  authorName: string;
  authorEmail?: string;
  isInternal: boolean; // If true, only visible to staff
  content: string;
  createdAt: Date;
}

